import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Modifier, ModifierType } from '@prlw/core/monitor/types/common';
import { AllTableModifiersService } from '@prlw/core/monitor/all-table-modifiers.service';

@Component({
  selector: 'prlw-modifiers',
  templateUrl: './modifiers.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifiersContainer {
  public modifier$: Observable<Modifier>;

  constructor(
    private readonly allTableModifiersState: AllTableModifiersService,
  ) {
    this.modifier$ = allTableModifiersState.modifier$;
  }

  public updatePrepaidMargin(prepaidMargin: string): void {
    if (prepaidMargin) {
      this.allTableModifiersState.updateModifier({
        type: ModifierType.PREPAID,
        data: {
          prepaidMargin: Number(prepaidMargin),
        },
      });
    }
  }

  public updateDefer([deferPercent, deferPeriod]: string[]): void {
    if (deferPercent || deferPeriod) {
      this.allTableModifiersState.updateModifier({
        type: ModifierType.DEFER,
        data: {
          deferPercent: Number(deferPercent),
          deferPeriod: Number(deferPeriod),
        },
      });
    }
  }
}
